export class GeneralError extends Error {
  constructor(message = "오류가 발생하였습니다.") {
    super(message);
  }
}
